export const USER_MEMBER_TYPES: {[key: string]: string} = {
    executive: "executive",
    member: "member",
    volunteer: "volunteer",
    sponsor: "sponsor"
}